export default {
  func: 'function'
};